<template>
  <SkeletonLoader>
    <div class="hd-skeleton">
      <div class="hd-skeleton__grid">
        <div v-for="day in 8" :key="'day-' + day" class="hd-skeleton__card">
          <div class="hd-skeleton__day-header">
            <div class="sk-line sk-line--title" :style="{ width: dayWidths[day] }"></div>
          </div>
          <div v-for="p in 3" :key="'prov-' + day + '-' + p" class="hd-skeleton__provider">
            <div class="hd-skeleton__prov-header">
              <div class="sk-line sk-line--sm" :style="{ width: provWidths[p] }"></div>
              <div class="sk-line sk-line--sm" style="width: 30px;"></div>
            </div>
            <div class="sk-rect" style="height: 6px; width: 100%; border-radius: 3px;"></div>
            <div class="hd-skeleton__prov-values">
              <div class="sk-line sk-line--sm" style="width: 60px;"></div>
              <div class="sk-line sk-line--sm" style="width: 50px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'HuddleDetailsSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      dayWidths: { 1: '70%', 2: '60%', 3: '75%', 4: '65%', 5: '70%', 6: '55%', 7: '80%', 8: '60%' },
      provWidths: { 1: '50%', 2: '65%', 3: '45%' },
    };
  }
}
</script>

<style lang="scss" scoped>
.hd-skeleton {
  padding: 16px;
}

.hd-skeleton__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.hd-skeleton__card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px;
}

.hd-skeleton__day-header {
  margin-bottom: 14px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
}

.hd-skeleton__provider {
  margin-bottom: 12px;
}

.hd-skeleton__prov-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.hd-skeleton__prov-values {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
}

@media (max-width: 1199px) {
  .hd-skeleton__grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 767px) {
  .hd-skeleton__grid { grid-template-columns: 1fr; }
}
</style>
